import validator from 'validator';
import { cacheService } from "./utils";
import { PORTAL_FORMAT } from '../constants/commons';
import Auth from '../models/Auth';
import { Link, useLocation } from 'react-router-dom';
import { t } from 'i18next';
import { RECENT_ACCESS_PART } from '../constants/recentAccess';
import NewInquiry from '../assets/images/new-inquiry.png';
import * as statusList from '../constants/statusColor';


export const EMAIL_REGEX = /^(([^<>()[\].,;:\s@"]+(.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}\])|(([a-zA-Z0-9-]+.)+[a-zA-Z]{2,}))$/;

export const PHONE_REGEX = /(^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s./0-9]*$)|(^[0-9]{2,3}[-\s./0-9]+$)/;

//const SPECIAL_REG = /[$+=?#|'<>^()%!]/
export const SPECIAL_REG = /[$=#|'<>^%!{}~]/;
export const CURR_REG = /[[\]+=#|'<>^%!@&(){}~]/;

export const PSWDRGX = /^((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W\-\_])).{8,}$/

export const isValidPasswd = (str) => {
    return PSWDRGX.test(str);
};

export const isHasSpecialChar = (str) => {
    return SPECIAL_REG.test(str);
};

export const isHasSpecialCharCurr = (str) => {
    return CURR_REG.test(str);
};

export const validatePhone = (value) => {
    let val = String(value).trim();
    // return validator.isMobilePhone(val);
    return PHONE_REGEX.test(val)
};

export const validateEmail = (value) => {
    let val = String(value).trim().toLowerCase();
    if (isHasSpecialChar(val)) return false;
    if (!EMAIL_REGEX.test(val)) return false;
    return validator.isEmail(val);
};

export const validateEmails = (value) => {
    let ems = String(value).trim().toLowerCase().split(/[\s;,]+/);
    if (ems.length === 0) {
        return false;
    }
    for (let e of ems) {
        if (!validateEmail(e)) return false
    }
    return true;
};

export function isSkTesEmail(value) {
    if (!validateEmail(value)) return false
    const patt = /@([a-zA-Z0-9.-_]+.)*((tes-amm.)|(sktes.))([a-zA-Z0-9.-_]+)+/;
    let val = String(value || "").trim();
    const valid = patt.test(val);
    return valid;
}

export function getCollectionSiteID(portalId, siteId) {
    if (!portalId || !siteId) return null;
    if (siteId.startsWith(portalId + '-')) {
        return siteId;
    }
    return `${portalId}-${siteId}`;
};

export const generatePassword = (len = 8) => {
    const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
    const numbers = "0123456789";
    const specialCharacters = `^$*.[]{}()?"!@#%&/\,><':;|_~\`=+-`;
    let password = '';
    password += uppercaseLetters.charAt(Math.floor(Math.random() * uppercaseLetters.length));
    password += lowercaseLetters.charAt(Math.floor(Math.random() * lowercaseLetters.length));
    password += numbers.charAt(Math.floor(Math.random() * numbers.length));
    password += specialCharacters.charAt(Math.floor(Math.random() * specialCharacters.length));

    while (password.length < len) {
        const allCharacters = uppercaseLetters + lowercaseLetters + numbers;
        password += allCharacters.charAt(Math.floor(Math.random() * allCharacters.length));
    }

    return password;
}

export function NewInquiryBtn() {
    const location = useLocation();
    return null;
    // return (
    //     Auth.hasRightAdd('CONTACT_US') ? (
    //         <Link to={RECENT_ACCESS_PART.NEW_INQUIRY.part + location.search}>
    //             <div className="new-inquiry">
    //                 <span>{t('NewInquiry')}</span>
    //                 <img src={NewInquiry} className="float-right" alt="" />
    //             </div>
    //         </Link>
    //     ) : null
    // );
}


export function makeDynamicBg(status) {
    let bg = ''
    let hover = ''
    if (status) {
        switch (status.toLowerCase()) {
            case statusList.PENDING_NAME.toLowerCase():
                bg = statusList.PENDING;
                hover = statusList.PENDING_HOVER;
                break;
            case statusList.NEW_NAME.toLowerCase():
                bg = statusList.NEW;
                hover = statusList.NEW_HOVER;
                break;
            case statusList.APPROVED_NAME.toLowerCase():
                bg = statusList.APPROVED
                hover = statusList.APPROVED_HOVER;
                break;
            case statusList.SCHEDULED_NAME.toLowerCase():
                bg = statusList.SCHEDULED
                hover = statusList.SCHEDULED_HOVER
                break;
            case statusList.REACHED_FACILITY_NAME.toLowerCase():
                bg = statusList.REACHED_FACILITY
                hover = statusList.REACHED_FACILITY_HOVER
                break;
            case statusList.REPORT_AVAILABLE_NAME.toLowerCase():
                bg = statusList.REPORT_AVAILABLE
                hover = statusList.REPORT_AVAILABLE_HOVER
                break;
            case statusList.PROCESSING_DONE_NAME.toLowerCase():
                bg = statusList.PROCESSING_DONE
                hover = statusList.PROCESSING_DONE_HOVER
                break;
            case statusList.REPORTING_DONE_NAME.toLowerCase():
                bg = statusList.REPORTING_DONE
                hover = statusList.REPORTING_DONE_HOVER
                break;
            case statusList.COD_DONE_NAME.toLowerCase():
                bg = statusList.COD_DONE
                hover = statusList.COD_DONE_HOVER
                break;
            case statusList.COMPLETED_NAME.toLowerCase():
                bg = statusList.COMPLETED
                hover = statusList.COMPLETED_HOVER
                break;
            case statusList.CANCEL_NAME.toLowerCase():
                bg = statusList.CANCEL
                hover = statusList.CANCEL_HOVER
                break;
            default:
                bg = statusList.OTHERS
                hover = statusList.OTHERS_HOVER
                break;
        }
    }
    return ({bgColor: bg, hoverColor: hover})
};

class Common {
    static getDateFormat() {
        let dateFormatsObj = cacheService.getCache("dateFormats");
        if (!dateFormatsObj || (dateFormatsObj && !dateFormatsObj.dateFormatByUser)) {
            dateFormatsObj = {
                dateFormatByUser: PORTAL_FORMAT.SHORT_DATE,
                dateFormatByUserWithHours: PORTAL_FORMAT.SHORT_DATETIME
            }
        }
        return dateFormatsObj;
    }

    static displayDateNewFormat = (d) => {
        function join(t, a, s) {
            function format(m) {
                let f = new Intl.DateTimeFormat('en', m);
                return f.format(t);
            }
            return a.map(format).join(s);
        }

        let a = [{ day: 'numeric' }, { month: 'long' }, { year: 'numeric' }];
        let s = join(d, a, ' ');
        return s;
    }

    static displayStatusDate = (d) => {
        if (d.isValid()) {
            return d.format(PORTAL_FORMAT.SHORT_DATE);
        }
        return '';
    }
    static batteryConditionColor = (item) => {
        if (!item || !item.batteryCondition) {
            return
        }
        if (item.batteryCondition === 'Amber' || item.batteryCondition === 'Gelb' || item.batteryCondition === 'Jaune' || item.batteryCondition === 'Yellow') {
            return 'material-amber'
        }
        if (item.batteryCondition === 'Red' || item.batteryCondition === 'Rot' || item.batteryCondition === 'Rouge') {
            return 'material-red'
        }
        if (item.batteryCondition === 'Green' || item.batteryCondition === 'Grün' || item.batteryCondition === 'Vert') {
            return 'material-green'
        }
    }

    static formatNumber = (number, isGermanyLng = false) => {
        if (!number || isNaN(number)) return 0;
        if (isGermanyLng) {
            // to Fix
            number = parseFloat(number).toFixed(2);
            // remove all commas and replace with dot
            return number.replace(/,/g, '').replace('.', ',');
        }
        return number;
    }

    static correctNumber = (number) => {
        if (!number) return 0;
        // replace first comma as dot and remove all other commas
        number = number.replace(',', '.').replace(/,/g, '');
        return parseFloat(number).toFixed(2);
    }
}
export default Common